import { Card, CardHeader, CardTitle } from '@/components/ui/Card'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { PasskeySettings } from '@/components/settings/PasskeySettings'
import { useAuth } from '@/contexts/AuthContext'
import {
  User,
  Building2,
  Bell,
  Shield,
  Palette,
  Save,
} from 'lucide-react'

export default function SettingsPage() {
  const { user } = useAuth()

  return (
    <div className="space-y-6">
      {/* Page header */}
      <div>
        <h1 className="text-2xl font-display font-bold text-brown-900">
          Parametres
        </h1>
        <p className="mt-1 text-brown-600">
          Configurez votre application CRM
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Settings navigation */}
        <div className="lg:col-span-1">
          <Card>
            <nav className="space-y-1">
              <button className="flex items-center w-full px-4 py-3 text-sm font-medium text-mint-700 bg-mint-50 rounded-lg">
                <User className="w-5 h-5 mr-3" />
                Profil
              </button>
              <button className="flex items-center w-full px-4 py-3 text-sm font-medium text-brown-600 hover:bg-beige-50 rounded-lg">
                <Building2 className="w-5 h-5 mr-3" />
                Entreprise
              </button>
              <button className="flex items-center w-full px-4 py-3 text-sm font-medium text-brown-600 hover:bg-beige-50 rounded-lg">
                <Bell className="w-5 h-5 mr-3" />
                Notifications
              </button>
              <button className="flex items-center w-full px-4 py-3 text-sm font-medium text-brown-600 hover:bg-beige-50 rounded-lg">
                <Shield className="w-5 h-5 mr-3" />
                Securite
              </button>
              <button className="flex items-center w-full px-4 py-3 text-sm font-medium text-brown-600 hover:bg-beige-50 rounded-lg">
                <Palette className="w-5 h-5 mr-3" />
                Apparence
              </button>
            </nav>
          </Card>
        </div>

        {/* Settings content */}
        <div className="lg:col-span-2 space-y-6">
          {/* Profile settings */}
          <Card>
            <CardHeader>
              <CardTitle>Informations du profil</CardTitle>
            </CardHeader>

            <form className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Input
                  label="Prenom"
                  placeholder="Votre prenom"
                  defaultValue=""
                />
                <Input
                  label="Nom"
                  placeholder="Votre nom"
                  defaultValue=""
                />
              </div>

              <Input
                label="Email"
                type="email"
                placeholder="votre@email.com"
                defaultValue={user?.email || ''}
                disabled
                helperText="L'email ne peut pas etre modifie"
              />

              <Input
                label="Telephone"
                type="tel"
                placeholder="06 12 34 56 78"
                defaultValue=""
              />

              <div className="flex justify-end">
                <Button leftIcon={<Save className="w-4 h-4" />}>
                  Sauvegarder
                </Button>
              </div>
            </form>
          </Card>

          {/* Sécurité : passkeys (WebAuthn) */}
          <PasskeySettings />

          {/* Company settings */}
          <Card>
            <CardHeader>
              <CardTitle>Informations de l'entreprise</CardTitle>
            </CardHeader>

            <form className="space-y-4">
              <Input
                label="Nom de l'entreprise"
                placeholder="Votre entreprise"
                defaultValue="Les Sables d'Olonne"
              />

              <Input
                label="Adresse"
                placeholder="Adresse complete"
                defaultValue=""
              />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Input
                  label="Code postal"
                  placeholder="85100"
                  defaultValue=""
                />
                <Input
                  label="Ville"
                  placeholder="Les Sables-d'Olonne"
                  defaultValue=""
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Input
                  label="SIRET"
                  placeholder="123 456 789 00012"
                  defaultValue=""
                />
                <Input
                  label="TVA Intracommunautaire"
                  placeholder="FR12345678901"
                  defaultValue=""
                />
              </div>

              <div className="flex justify-end">
                <Button leftIcon={<Save className="w-4 h-4" />}>
                  Sauvegarder
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    </div>
  )
}
